import React from "react";
import { Button, Divider, Typography } from "@material-ui/core";

// Localizacao na conversa: mini mapa + nome/endereco + botao para abrir.
// Aceita os dois formatos gravados: "link|descricao" (recebida) e
// "imagem|link|descricao" (antigo / enviada pela assistente).
const coordenadas = (texto) => {
  const m = decodeURIComponent(String(texto || "")).match(/(-?\d+\.\d+)\s*(?:%2C|,)\s*(-?\d+\.\d+)/i);
  return m ? { lat: m[1], lng: m[2] } : null;
};

const LocationPreview = ({ image, link, description }) => {
  const partes = [image, link, description].filter((p) => p !== undefined && p !== null);
  const url = partes.find((p) => /^https?:\/\//i.test(String(p))) || "";
  const textos = partes.filter((p) => p && !/^https?:\/\//i.test(String(p)));
  const descricao = textos.join("\n").replace(/\\n/g, "\n");
  const c = coordenadas(url);
  const embed = c ? `https://maps.google.com/maps?q=${c.lat},${c.lng}&z=16&hl=pt-BR&output=embed` : "";
  const abrir = c ? `https://www.google.com/maps/search/?api=1&query=${c.lat}%2C${c.lng}` : url;

  return (
    <div style={{ minWidth: 250, maxWidth: 300 }}>
      {embed ? (
        <iframe
          title="Localização"
          src={embed}
          loading="lazy"
          style={{ display: "block", width: "100%", height: 150, border: 0, borderRadius: 8 }}
        />
      ) : null}
      {descricao && (
        <Typography variant="body2" style={{ margin: "8px 4px", whiteSpace: "pre-wrap", fontWeight: 600 }}>
          📍 {descricao}
        </Typography>
      )}
      <Divider />
      <Button fullWidth color="primary" disabled={!abrir} onClick={() => window.open(abrir, "_blank", "noopener")}>
        Abrir no Google Maps
      </Button>
    </div>
  );
};

export default LocationPreview;
